import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {

    return (
        <div style={{ background: 'linear-gradient(45deg, #2c3e50, #34495e)', color: '#fff', padding: '20px 10px', textAlign: 'center', fontFamily: 'Arial, sans-serif', }}>
            <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', marginBottom: '10px', }}>

                <div style={{ width: '250px', margin: '10px', textAlign: 'left', padding: '10px', }}>
                    <h3 style={{ fontSize: '20px', marginBottom: '10px', fontWeight: 'bold', textTransform: 'uppercase', }}>Company</h3>
                    <p style={{ color: 'white' }}>Technology has brought about a rapid turnaround in the dynamics of today's business. With the growing challenges both in the business as well as technological domains, there is a dire need to concentrate on core competencies, and to have shorter product lifecycles</p>
                </div>

                {/* Quick Links Section */}
                <div style={{
                    width: '250px',
                    margin: '10px',
                    textAlign: 'left',
                    padding: '10px',
                }}>
                    <h3 style={{
                        fontSize: '20px',
                        marginBottom: '10px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                    }}>Quick Links</h3>
                    <a href="/education-terms" style={{
                        color: '#ecf0f1',
                        textDecoration: 'none',
                        display: 'block',
                        margin: '5px 0',
                        fontSize: '16px',
                        transition: 'color 0.3s ease, text-decoration 0.3s ease',
                    }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                        Education
                    </a>
                    <a href="/health-care" style={{
                        color: '#ecf0f1',
                        textDecoration: 'none',
                        display: 'block',
                        margin: '5px 0',
                        fontSize: '16px',
                        transition: 'color 0.3s ease, text-decoration 0.3s ease',
                    }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                        Healthcare
                    </a>
                    <a href="/Marketing-Terms" style={{
                        color: '#ecf0f1',
                        textDecoration: 'none',
                        display: 'block',
                        margin: '5px 0',
                        fontSize: '16px',
                        transition: 'color 0.3s ease, text-decoration 0.3s ease',
                    }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                        Marketing
                    </a>
                    <a href="/Sales-Terms" style={{
                        color: '#ecf0f1',
                        textDecoration: 'none',
                        display: 'block',
                        margin: '5px 0',
                        fontSize: '16px',
                        transition: 'color 0.3s ease, text-decoration 0.3s ease',
                    }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                        Sales
                    </a>
                </div>

                {/* Contact Section */}
                <div style={{ width: '250px', margin: '10px', textAlign: 'left', padding: '10px', }}>
                    <h3 style={{ fontSize: '20px', marginBottom: '10px', fontWeight: 'bold', textTransform: 'uppercase', }}>Contact</h3>
                    <p style={{ color: 'white' }}>Unit #208, Ashoka Bhopal Chambers,
                        Sardar Patel Rd, Hyderabad-500062,
                        Telangana, INDIA</p>
                    <a href="tel:+91 9849164361" style={{ color: '#ecf0f1', textDecoration: 'none', display: 'block', margin: '5px 0', fontSize: '16px', transition: 'color 0.3s ease, text-decoration 0.3s ease', }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                        <FaPhoneAlt style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                        +91 9849164361
                    </a>
                    <a href="mailto:info@emedha.com" style={{ color: '#ecf0f1', textDecoration: 'none', display: 'block', margin: '5px 0', fontSize: '16px', transition: 'color 0.3s ease, text-decoration 0.3s ease', }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                        <FaEnvelope style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                        info@emedha.com
                    </a>
                </div>

                {/* Social Media Section */}
                <div style={{ width: '250px', margin: '10px', textAlign: 'left', padding: '10px', }}>
                    <h3 style={{ fontSize: '20px', marginBottom: '10px', fontWeight: 'bold', textTransform: 'uppercase', }}>Follow Us</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <a href="https://www.facebook.com/emedha" target="_blank" rel="noopener noreferrer" style={{
                            color: '#ecf0f1',
                            fontSize: '24px',
                            margin: '0 10px',
                            transition: 'color 0.3s ease, text-decoration 0.3s ease',
                        }}
                            onMouseEnter={(e) => e.target.style.color = '#3b5998'}
                            onMouseLeave={(e) => e.target.style.color = '#ecf0f1'}
                            onMouseDown={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseUp={(e) => e.target.style.textDecoration = 'none'}>
                            <FaFacebook />
                        </a>
                        <a href="https://x.com/i/flow/login?redirect_after_login=%2Femedha" target="_blank" rel="noopener noreferrer" style={{
                            color: '#ecf0f1',
                            fontSize: '24px',
                            margin: '0 10px',
                            transition: 'color 0.3s ease, text-decoration 0.3s ease',
                        }}
                            onMouseEnter={(e) => e.target.style.color = '#00acee'}
                            onMouseLeave={(e) => e.target.style.color = '#ecf0f1'}
                            onMouseDown={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseUp={(e) => e.target.style.textDecoration = 'none'}>
                            <FaTwitter />
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" style={{
                            color: '#ecf0f1',
                            fontSize: '24px',
                            margin: '0 10px',
                            transition: 'color 0.3s ease, text-decoration 0.3s ease',
                        }}
                            onMouseEnter={(e) => e.target.style.color = '#0e76a8'}
                            onMouseLeave={(e) => e.target.style.color = '#ecf0f1'}
                            onMouseDown={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseUp={(e) => e.target.style.textDecoration = 'none'}>
                            <FaLinkedin />
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" style={{
                            color: '#ecf0f1',
                            fontSize: '24px',
                            margin: '0 10px',
                            transition: 'color 0.3s ease, text-decoration 0.3s ease',
                        }}
                            onMouseEnter={(e) => e.target.style.color = '#C13584'}
                            onMouseLeave={(e) => e.target.style.color = '#ecf0f1'}
                            onMouseDown={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseUp={(e) => e.target.style.textDecoration = 'none'}>
                            <FaInstagram />
                        </a>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '20px', fontSize: '14px', borderTop: '1px solid #ecf0f1', paddingTop: '10px', }}>
                <p style={{ color: 'white', fontSize: '14px', textTransform: 'uppercase', }}>
                    &copy; 2025 Company eMedha Technologies. All Rights Reserved.
                </p>
            </div>
        </div>
    );
};

export default Footer;
